import queryString from 'query-string';
import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { ApiMetabaseEmbeddedRequest } from './Types';

export class AnalyticsRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/analytics/v1/kpis';
  }

  public getFromMetabaseEmbeddedDashboardApi = async (dashboardId: number): Promise<string> => {
    const emptyRequest: ApiMetabaseEmbeddedRequest = { parameters: {} };

    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/metabase/embed/dashboard/${dashboardId}`,
      method: HttpMethod.POST,
      body: JSON.stringify(emptyRequest),
    };
    const { data } = await this.requester.request(requestData);

    return `${data.data}`;
  };

  public getFromMetabaseQueryParams = (request: ApiMetabaseEmbeddedRequest): string => {
    // search_params
    const searchParams = queryString.stringify(request.parameters);

    // hide widget filters
    const parameters = Object.keys(request.parameters);
    const hideParameters = `hide_parameters=${parameters.join(',')}`;

    // style
    const style = 'bordered=false&titled=false';

    return `${searchParams}#${hideParameters}&${style}`;
  };
}

export default AnalyticsRequester;
